var map = {
	"./gameplay.json": 72603,
	"./storm_league.json": 3176
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__.t(id, 3 | 16);
});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 15959;
module.exports = webpackAsyncContext;